export default __webpack_public_path__ + "e9b6fc70c63512079f32995e40d912da.png";